PegasusTemplate.Router.reopen({location: 'none'});

PegasusTemplate.Router.map(function() {
  this.resource('loading');
  this.resource('template', { path: '/template/:template_id' }, function(){
    this.route('preview');
    // TODO - migrate to editing in new framework and also use stateManager
    //this.resource('social_shares', function(){
      //this.resource('social_share', { path: ':fragment_id'}, function(){
        //this.route('edit');
      //});
    //});
    //this.resource('weblinks', function(){
      //this.resource('weblink', { path: ':fragment_id' }, function(){
        //this.route('edit');
      //});
    //});
  });
});
